/* eslint-disable */
import React, { useState } from 'react'
import MuiAlert from '@material-ui/lab/Alert';
import { makeStyles } from '@material-ui/core/styles';

// import styles 
import styles from './AlertBar.css';

const getDefaultStyle = (style, theme) => {
  return {
    root: style,
  }
}

const AlertBar = props => {
  const [open, setOpen] = useState(true);
  const {
    severity,
    overrideStyle = null,
    textMsg = '',
    autoClose = false, 
    onClickClose = () =>{console.log("Alert Closed!")},
  } = props

  const useStyles = makeStyles((theme) => (getDefaultStyle(overrideStyle, theme)));
  const classes = useStyles();

  // close the Alert POP-UP
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
    onClickClose();
  };

  setTimeout(() => {
    if (autoClose) {
      setOpen(false);
      onClickClose();
    }
  }, 3000);

  const Alert = props => {
    return <MuiAlert
      className={overrideStyle && classes.root} // if not passed - default style of Alert
      elevation={6}
      variant="filled"
      {...props}
    />;
  }

  return (
    <React.Fragment>
      {open &&
        <Alert
          onClose={handleClose}
          severity={severity}>
          {textMsg}
        </Alert>
      }
    </React.Fragment >
  )
}

export default AlertBar;



// WEBPACK FOOTER //
// ./src/views/components/Common/AlertBar/AlertBar.jsx